import { Dialog } from '@mui/material';

import { ConversationType } from '../../../../enums/chat';
import ConversationHeader from '../ConversationHeader';
import ConversationContent from '../ConversationContent/index';
import { modalColors } from '../DiscussionsModal/styled';

interface ConversationModalProps {
    open: boolean;
    onClose: () => void;
    conversationId: number;
    conversationType: ConversationType;
    entityId: string;
    title: string;
    subtitle?: string;
    showSearch?: boolean;
    allowReactions?: boolean;
}

const dialogStyles = {
    '& .MuiPaper-root': {
        backgroundColor: modalColors.black3,
        color: modalColors.white,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        height: '800px'
    }
};

export default function ConversationModal({
    open,
    onClose,
    conversationId,
    entityId,
    title,
    subtitle,
    showSearch = true,
    allowReactions = true
}: ConversationModalProps): JSX.Element {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            sx={dialogStyles}
        >
            <ConversationHeader
                title={title}
                subtitle={subtitle}
                onClose={onClose}
                showCloseButton={true}
            />

            <ConversationContent
                conversationId={conversationId}
                entityId={entityId}
                showSearch={showSearch}
                allowReactions={allowReactions}
            />
        </Dialog>
    );
}
